module.exports = __webpack_public_path__ + "img/Tests.bf057bd3.png";